import { render, staticRenderFns } from "./LotReport.vue?vue&type=template&id=2d38a9b6&"
import script from "./LotReport.vue?vue&type=script&lang=js&"
export * from "./LotReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports